import { useEffect, useState } from "react";
import { Outlet, NavLink, useNavigate, Link } from "react-router-dom";
import { LogOut, Newspaper, BookOpen, Inbox, ExternalLink, HelpCircle } from "lucide-react";
import { api } from "@/lib/api";

export default function AdminLayout() {
  const [authed, setAuthed] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem("gpi_admin_token");
    if (!token) {
      navigate("/admin/login");
      return;
    }
    api
      .get("/auth/me")
      .then(() => setAuthed(true))
      .catch(() => {
        localStorage.removeItem("gpi_admin_token");
        navigate("/admin/login");
      });
  }, [navigate]);

  const logout = () => {
    localStorage.removeItem("gpi_admin_token");
    navigate("/admin/login");
  };

  if (!authed) {
    return <div className="min-h-screen flex items-center justify-center text-[#64748B]">Chargement...</div>;
  }

  const linkClass = ({ isActive }) =>
    `flex items-center gap-3 px-4 py-2.5 text-sm transition-colors ${
      isActive
        ? "bg-[#0F172A] text-white"
        : "text-[#475569] hover:bg-[#EFE8DC] hover:text-[#0F172A]"
    }`;

  return (
    <div className="min-h-screen bg-[#F9F8F6] flex" data-testid="admin-layout">
      <aside className="w-64 border-r border-[#E2E8F0] bg-white flex flex-col">
        <div className="p-6 border-b border-[#E2E8F0] bg-[#0F172A]">
          <Link to="/" className="flex items-center gap-3">
            <img
              src="/assets/logo-cabinet-gpi.png"
              alt="Cabinet GPI Immobilier"
              className="h-16 w-auto object-contain"
            />
            <div>
              <div className="font-overline text-[10px] text-[#D4B584]">Back-office</div>
            </div>
          </Link>
        </div>
        <nav className="p-3 flex-1 space-y-1">
          <NavLink to="/admin/articles" data-testid="admin-nav-articles" className={linkClass}>
            <Newspaper size={16} />
            Actualités
          </NavLink>
          <NavLink to="/admin/lexique" data-testid="admin-nav-lexique" className={linkClass}>
            <BookOpen size={16} />
            Lexique
          </NavLink>
          <NavLink to="/admin/faq" data-testid="admin-nav-faq" className={linkClass}>
            <HelpCircle size={16} />
            FAQ
          </NavLink>
          <NavLink to="/admin/contacts" data-testid="admin-nav-contacts" className={linkClass}>
            <Inbox size={16} />
            Messages
          </NavLink>
        </nav>
        <div className="p-3 border-t border-[#E2E8F0] space-y-1">
          <Link
            to="/"
            target="_blank"
            className="flex items-center gap-3 px-4 py-2.5 text-sm text-[#475569] hover:bg-[#EFE8DC]"
          >
            <ExternalLink size={16} />
            Voir le site
          </Link>
          <button
            onClick={logout}
            data-testid="admin-logout-btn"
            className="w-full flex items-center gap-3 px-4 py-2.5 text-sm text-[#475569] hover:bg-[#EFE8DC]"
          >
            <LogOut size={16} />
            Déconnexion
          </button>
        </div>
      </aside>
      <main className="flex-1 overflow-auto">
        <div className="max-w-6xl mx-auto p-8 lg:p-12">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
